// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/ongoing_assessment.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssessmentScore } from "../../assessment/v1/assessment_score_pb";
import { file_assessment_v1_assessment_score } from "../../assessment/v1/assessment_score_pb";
import type { User } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CompanyLifecycle } from "./company_lifecycle_pb";
import { file_inventory_v1_company_lifecycle } from "./company_lifecycle_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { QuestionnaireStatus } from "../../questionnaire/common/v1/questionnaire_status_pb";
import { file_questionnaire_common_v1_questionnaire_status } from "../../questionnaire/common/v1/questionnaire_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/ongoing_assessment.proto.
 */
export const file_inventory_v1_ongoing_assessment: GenFile = /*@__PURE__*/
  fileDesc("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", [file_assessment_v1_assessment_score, file_customer_management_v1_service, file_google_protobuf_timestamp, file_inventory_v1_company_lifecycle, file_inventory_v1_risk, file_questionnaire_common_v1_questionnaire_status]);

/**
 * @generated from message inventory.v1.OngoingAssessment
 */
export type OngoingAssessment = Message<"inventory.v1.OngoingAssessment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_company_id = 2;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string org_company_name = 3;
   */
  orgCompanyName: string;

  /**
   * @generated from field: optional string project_id = 4;
   */
  projectId?: string;

  /**
   * @generated from field: optional string project_name = 5;
   */
  projectName?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 6;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional string past_assessment_id = 7;
   */
  pastAssessmentId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 8;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: inventory.v1.OngoingAssessmentStatus status = 9;
   */
  status: OngoingAssessmentStatus;

  /**
   * @generated from field: optional string org_company_business_owner_name = 10;
   */
  orgCompanyBusinessOwnerName?: string;

  /**
   * @generated from field: repeated string org_company_point_of_contact_names = 11;
   */
  orgCompanyPointOfContactNames: string[];

  /**
   * @generated from field: inventory.v1.CompanyLifecycle org_company_lifecycle = 12;
   */
  orgCompanyLifecycle: CompanyLifecycle;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.RiskLevel org_company_inherent_risk = 14;
   */
  orgCompanyInherentRisk?: RiskLevel;

  /**
   * @generated from field: repeated customer.management.v1.User assignees = 15;
   */
  assignees: User[];

  /**
   * @generated from field: assessment.v1.AssessmentScore score = 16;
   */
  score: AssessmentScore;

  /**
   * @generated from field: optional inventory.v1.RiskLevel org_company_validated_risk = 17;
   */
  orgCompanyValidatedRisk?: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel org_company_calculated_risk = 18;
   */
  orgCompanyCalculatedRisk?: RiskLevel;

  /**
   * @generated from field: optional customer.management.v1.User concluded_by = 19;
   */
  concludedBy?: User;

  /**
   * @generated from field: optional google.protobuf.Timestamp concluded_at = 20;
   */
  concludedAt?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.SmartEvidenceRequest smart_evidence_request = 21;
   */
  smartEvidenceRequest?: SmartEvidenceRequest;

  /**
   * Distinct org_scope ids that routed controls into this assessment
   *
   * @generated from field: repeated string scope_ids = 22;
   */
  scopeIds: string[];

  /**
   * The user who started the assessment. Absent for system-started
   * (webhook / procurement request) assessments and those created before
   * this field existed.
   *
   * @generated from field: optional customer.management.v1.User created_by = 23;
   */
  createdBy?: User;
};

/**
 * Describes the message inventory.v1.OngoingAssessment.
 * Use `create(OngoingAssessmentSchema)` to create a new message.
 */
export const OngoingAssessmentSchema: GenMessage<OngoingAssessment> = /*@__PURE__*/
  messageDesc(file_inventory_v1_ongoing_assessment, 0);

/**
 * SmartEvidenceRequestSummary carries the risk questionnaire's smart-evidence-request state for an ongoing assessment
 *
 * @generated from message inventory.v1.SmartEvidenceRequest
 */
export type SmartEvidenceRequest = Message<"inventory.v1.SmartEvidenceRequest"> & {
  /**
   * @generated from field: questionnaire.common.v1.QuestionnaireStatus questionnaire_status = 1;
   */
  questionnaireStatus: QuestionnaireStatus;

  /**
   * @generated from field: google.protobuf.Timestamp status_updated_at = 2;
   */
  statusUpdatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.SmartEvidenceRequest.
 * Use `create(SmartEvidenceRequestSchema)` to create a new message.
 */
export const SmartEvidenceRequestSchema: GenMessage<SmartEvidenceRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_ongoing_assessment, 1);

/**
 * @generated from enum inventory.v1.OngoingAssessmentStatus
 */
export enum OngoingAssessmentStatus {
  /**
   * @generated from enum value: ONGOING_ASSESSMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ONGOING_ASSESSMENT_STATUS_READY_TO_START = 1;
   */
  READY_TO_START = 1,

  /**
   * @generated from enum value: ONGOING_ASSESSMENT_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: ONGOING_ASSESSMENT_STATUS_AWAITING_APPROVAL = 3;
   */
  AWAITING_APPROVAL = 3,

  /**
   * @generated from enum value: ONGOING_ASSESSMENT_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,
}

/**
 * Describes the enum inventory.v1.OngoingAssessmentStatus.
 */
export const OngoingAssessmentStatusSchema: GenEnum<OngoingAssessmentStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_ongoing_assessment, 0);

